import { useMutation } from "react-query";
import http from "infra/http";
import { showErrorAxios } from "infra/helpers/alerta";

function useReprocessarConta() {
  return useMutation(
    (ids: string[]) => {
      return http.post(`/v1/conta/reprocessar`, {
        ids,
      });
    },
    {
      retry: false,
      onError: (e) => {
        showErrorAxios(e);
      },
    }
  );
}

export default useReprocessarConta;
